import {
  RevisionPromptInput,
  Props as PromptProps,
} from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/RevisionPromptInput'
import { useAlmanacEditorState } from 'stores/EditorState'
import { selectionFromRevision } from 'components/AIRevision/selectionFromRevision'

interface Props extends Pick<PromptProps, 'onChange' | 'isActive' | 'previousRevisionId' | 'menuOffsetOptions'> {
  articleId: string
  layerId: string
  customPrompt: string
  submitIconSize?: 'xs' | 'sm' | 'md' | 'lg'
  inputSize?: 'sm' | 'md'
}

export const RevisionPrompt = ({
  articleId,
  layerId,
  isActive,
  onChange,
  previousRevisionId,
  customPrompt,
  menuOffsetOptions,
  submitIconSize,
  inputSize,
}: Props) => {
  const editorState = useAlmanacEditorState()

  if (!editorState) return null

  const selection = selectionFromRevision(editorState.view.state.doc)

  return (
    <RevisionPromptInput
      previousRevisionId={previousRevisionId}
      selection={selection || undefined}
      isActive={isActive}
      articleId={articleId}
      layerId={layerId}
      editorState={editorState}
      onChange={onChange}
      customPrompt={customPrompt}
      menuOffsetOptions={menuOffsetOptions}
      submitIconSize={submitIconSize}
      inputSize={inputSize}
    />
  )
}
